import axios from 'axios'
import {
  UNAUTH_USER,
  AUTH_USER,
  AUTH_ERROR,
  FETCH_MESSAGE,
  FILTERPARAMS,
  FILTERPARAMS_SET,
  OPEN_PERSON,
  CLOSE_PERSON,
  MORE_MESSAGE,
  GET_QUALIFICATION,
  GET_QUALIFICATIONTYPES,
  GET_MEMBERSHIP,
  GET_PERSONCATEGORIES,
  GET_AFFAIRCATEGORIES,
  GET_NAMES,
  GET_FEES,
  GET_GROUPS,
  GET_FEETYPES,
  OPEN_FEE,
  CLOSE_FEE,
  GET_AUTOCOMPLETE,
  GET_MOREAUTOCOMPLETE,
  GET_AUTOCOMPLETE2,
  GET_MOREAUTOCOMPLETE2,
  GET_AUTOCOMPLETEAFFAIR,
  GET_AUTOCOMPLETE4,
  GET_MOREAUTOCOMPLETE4,
  GET_AUTOCOMPLETE5,
  GET_MOREAUTOCOMPLETE5,
  OPEN_AFFAIR,
  CLOSE_AFFAIR,
  GET_AFFAIRSTATUS,
  GET_AFFAIRAUTOMATED,
  OPEN_SETTING,
  CLOSE_SETTING,
  OPEN_GROUP,
  CLOSE_GROUP,
  GET_GROUPTYPES,
  OPEN_GROUPREGISTRATIONFEE,
  GET_TRAININGSTATUS,
  GET_GROUPSBYYEAR,
  GET_GROUPSBYLESSONCOUNT,
  GET_PARTICIPANTAMOUNTS,
  GET_TOPLEADERS,
  GET_TOPLEADERSMORE,
  GET_FEEOVERVIEW,
  GET_DEBITORSONEYEAR,
  GET_DEBITORSTWOYEAR,
  GET_DEBITORSONEYEARMORE,
  GET_DEBITORSTWOYEARMORE
} from './types'
import CONS from '../constants';
import { browserHistory } from 'react-router-dom'

// Host url from the config file
const ROOT_URL = CONS.host;
var IE = false;
if ( typeof window.CustomEvent !== "function" ) {
  IE = true;
}
(function () {
  if ( typeof window.CustomEvent === "function" ) return false; //If not IE

  function CustomEvent ( event, params ) {
    params = params || { bubbles: false, cancelable: false, detail: undefined };
    var evt = document.createEvent( 'CustomEvent' );
    evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
    return evt;
   }

  CustomEvent.prototype = window.Event.prototype;

  window.CustomEvent = CustomEvent;
})();
// Number format
const renderNumber = function(number) {
  Number.prototype.format = function(n, x, s, c) {
      var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')',
          num = this.toFixed(Math.max(0, ~~n));

      return (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || ','));
  };
  return number.format(0, 3, ' ', '.')
}
/*
  Use:
  let number = parseInt('10000');
  console.log(renderNumber(number))
*/

// Auth
  export function refreshUser() {
    if (typeof localStorage.getItem('refreshToken') !== 'undefined') {
      return function (dispatch) {
        axios.post(`${ROOT_URL}/auth.refresh`, {
          token: localStorage.getItem('refreshToken')
        })
          .then(response => {
            // -Save tokens
            localStorage.setItem('token', response.data.accessToken)
            localStorage.setItem('refreshToken', response.data.refreshToken)
            localStorage.setItem('validUntil', response.data.validUntil)
            dispatch({type: AUTH_USER})
          })
          .catch(() => {
            dispatch({type: UNAUTH_USER})
          })
      }
    }
  }
  export function signinUser({email, password}) {
    return function (dispatch) {
      // submit login and password to server
      const request = axios.post(`${ROOT_URL}/auth.login`, {'userName':email, 'password':password})
      request
        .then(response => {
          // console.log(response.data);
          // console.log(response.status);
          // console.log(response.statusText);
          // console.log(response.headers);
          // console.log(response.config);
          // -Save tokens
          localStorage.setItem('token', response.data.accessToken)
          localStorage.setItem('refreshToken', response.data.refreshToken)
          localStorage.setItem('validUntil', response.data.validUntil)

          // -if request is good, we need to update state to indicate user is authenticated
          dispatch({type: AUTH_USER})
        })

        // If request is bad...
        // -Show an error to the user
        .catch(() => {
          dispatch(authError('Érvénytelen felhasználónév, vagy jelszó.'))
        })

    }
  }
  export function signoutUser() {
    localStorage.removeItem('token')
    localStorage.removeItem('refreshToken')
    localStorage.removeItem('validUntil')
    //this.props.history.push('/login')
    return {
      type: UNAUTH_USER
    }
  }
  export function authError(error) {
    return {
      type: AUTH_ERROR,
      payload: error
    }
  }

// All list
  export function fetchMessage(endpoint, params, autocomplete) {
    return function (dispatch) {
      let d = new Date();
      let t = d.getTime();
      //if (endpoint !== '/stats/affair-amounts') {
        if (endpoint.indexOf('?') > -1 || params.indexOf('?') > -1) {
          params = encodeURI(params)+'&t='+t
        } else {
          params = encodeURI(params)+'?t='+t
        }
      //}
      axios.get(ROOT_URL+endpoint+params, {
        headers: {'X-Auth-Token': localStorage.getItem('token')}
      })
        .then(response => {
          if (autocomplete === 'autocomplete') {
            dispatch({
              type: GET_AUTOCOMPLETE,
              payload: response.data
            })
          } else if (autocomplete === 'autocomplete2') {
            dispatch({
              type: GET_AUTOCOMPLETE2,
              payload: response.data
            })
          } else if (autocomplete === 'autocomplete3') {
            dispatch({
              type: GET_AUTOCOMPLETEAFFAIR,
              payload: response.data
            })
          } else if (autocomplete === 'autocomplete4') {
            dispatch({
              type: GET_AUTOCOMPLETE4,
              payload: response.data
            })
          } else if (autocomplete === 'autocomplete5') {
            dispatch({
              type: GET_AUTOCOMPLETE5,
              payload: response.data
            })
          } else {
            dispatch({
              type: FETCH_MESSAGE,
              payload: response.data
              // payload: response.data
            })
          }
        })

        // If request is bad...
        // - Try refresh token
        .catch((response) => {
          if (response.status === 401) {
            if (autocomplete !== 'autocomplete' && autocomplete !== 'autocomplete2' && autocomplete !== 'get_autocompleteaffair' && autocomplete !== 'get_autocomplete4' && autocomplete !== 'get_autocomplete5') {
              axios.post(`${ROOT_URL}/auth.refresh`, {
                token: localStorage.getItem('refreshToken')
              })
                .then(response => {
                  // -Save tokens
                  localStorage.setItem('token', response.data.accessToken)
                  localStorage.setItem('refreshToken', response.data.refreshToken)
                  localStorage.setItem('validUntil', response.data.validUntil)

                  // -if request is good, we may send again our request
                  axios.get(ROOT_URL+endpoint+params, {
                    headers: {'X-Auth-Token': localStorage.getItem('token')}
                  })
                    .then(response => {
                      if (response.status === 200) {
                        dispatch({
                          type: FETCH_MESSAGE,
                          payload: response.data
                        })
                      } else {
                        signoutUser()
                        this.props.history.push('/login')
                      }
                    })

                })
                .catch(() => {
                  this.props.dispatch(signoutUser())
                  this.props.history.push('/login')
                  //this.props.history.push('/registrationStep2')
                  
                })
            }
          } else if (response.status > 401 || response.status === 400) {
            var messageplus = '';
            if (typeof response.details !== 'undefined') {
              response.details.map((option, index) => {
                messageplus = messageplus+option+' '
              })
            }
            alert('Hiba történt. A szerver válasza:'+response.message+'\n'+messageplus)
          }
        })
    }
  }
  export function fetchMoreMessage(endpoint, params, autocomplete) {
    return function (dispatch) {
      let d = new Date();
      let t = d.getTime();
      if (endpoint.indexOf('?') > -1 || params.indexOf('?') > -1) {
        params = encodeURI(params)+'&t='+t
      } else {
        params = encodeURI(params)+'?t='+t
      }
      axios.get(ROOT_URL+endpoint+params, {
        headers: {'X-Auth-Token': localStorage.getItem('token')}
      })
        .then(response => {
          if (autocomplete === 'autocomplete') {
            dispatch({
              type: GET_MOREAUTOCOMPLETE,
              payload: response.data
            })
          } else if (autocomplete === 'autocomplete2') {
            dispatch({
              type: GET_MOREAUTOCOMPLETE2,
              payload: response.data
            })
          } else if (autocomplete === 'autocomplete4') {
            dispatch({
              type: GET_MOREAUTOCOMPLETE4,
              payload: response.data
            })
          } else if (autocomplete === 'autocomplete5') {
            dispatch({
              type: GET_MOREAUTOCOMPLETE5,
              payload: response.data
            })
          } else {
            dispatch({
              type: MORE_MESSAGE,
              payload: response.data
              // payload: response.data
            })
          }
        })

        // If request is bad...
        // - Try refresh token
        .catch((response) => {
          if (response.status === 401) {
            if (autocomplete !== 'autocomplete' && autocomplete !== 'autocomplete2' && autocomplete !== 'get_autocompleteaffair' && autocomplete !== 'get_autocomplete4' && autocomplete !== 'get_autocomplete5') {
              axios.post(`${ROOT_URL}/auth.refresh`, {
                token: localStorage.getItem('refreshToken')
              })
                .then(response => {
                  // -Save tokens
                  localStorage.setItem('token', response.data.accessToken)
                  localStorage.setItem('refreshToken', response.data.refreshToken)
                  localStorage.setItem('validUntil', response.data.validUntil)

                  // -if request is good, we may send again our request
                  axios.get(ROOT_URL+endpoint+params, {
                    headers: {'X-Auth-Token': localStorage.getItem('token')}
                  })
                    .then(response => {
                      if (response.status === 200) {
                        dispatch({
                          type: MORE_MESSAGE,
                          payload: response.data
                          // payload: response.data
                        })
                      } else {
                        signoutUser()
                        this.props.history.push('/login')
                      }
                    })

                })
                .catch(() => {
                  this.props.dispatch(signoutUser())
                  this.props.history.push('/login')
                  //this.props.history.push('/registrationStep2')
                  
                })
            }
          } else if (response.status > 401 || response.status === 400) {
            var messageplus = '';
            if (typeof response.details !== 'undefined') {
              response.details.map((option, index) => {
                messageplus = messageplus+option+' '
              })
            }
            alert('Hiba történt. A szerver válasza:'+response.message+'\n'+messageplus)
          }
        })
    }
  }

// select and list helper - enum values, names
  // reducer selector controlled by 'type'
  const dispatcher = (dispatch, response, type, track) => {
    if (type == 'Qualification') {
      dispatch({
        type: GET_QUALIFICATION,
        qualification: response.data
        // payload: response.data
      })
    }
    else if (type == 'QualificationTypes') {
      dispatch({
        type: GET_QUALIFICATIONTYPES,
        qualificationtypes: response.data
        // payload: response.data
      })
    }
    else if (type == 'Membership') {
      dispatch({
        type: GET_MEMBERSHIP,
        membership: response.data
      })
    }
    else if (type == 'PersonCategories') {
      dispatch({
        type: GET_PERSONCATEGORIES,
        personcategories: response.data
        // payload: response.data
      })
    }
    else if (type == 'Names') {
      dispatch({
        type: GET_NAMES,
        names: response.data
      })
    }
    else if (type == 'Fees') {
      dispatch({
        type: GET_FEES,
        fees: response.data
        // payload: response.data
      })
    }
    else if (type == 'Groups') {
      dispatch({
        type: GET_GROUPS,
        groups: response.data
        // payload: response.data
      })
    }
    else if (type == 'GroupInit') {
      dispatch({
        type: GET_GROUPS,
        groups: response.data,
        track: track
        // payload: response.data
      })
    }
    else if (type == 'FeeTypes') {
      dispatch({
        type: GET_FEETYPES,
        feetypes: response.data
        // payload: response.data
      })
    }
    else if (type == 'AffairCategories') {
      dispatch({
        type: GET_AFFAIRCATEGORIES,
        affaircategories: response.data
        // payload: response.data
      })
    }
    else if (type == 'AffairStatus') {
      dispatch({
        type: GET_AFFAIRSTATUS,
        affairstatus: response.data
        // payload: response.data
      })
    }
    else if (type == 'AffairAutomated') {
      dispatch({
        type: GET_AFFAIRAUTOMATED,
        affairautomated: response.data
        // payload: response.data
      })
    }
    else if (type == 'GroupTypes') {
      dispatch({
        type: GET_GROUPTYPES,
        grouptypes: response.data
        // payload: response.data
      })
    }
    else if (type == 'TrainingStatus') {
      dispatch({
        type: GET_TRAININGSTATUS,
        trainingstatus: response.data
        // payload: response.data
      })
    }
    else if (type == 'GroupsByYear') {
      dispatch({
        type: GET_GROUPSBYYEAR,
        groupsbyyear: response.data
      })
    }
    else if (type == 'GroupsByLessonCount') {
      dispatch({
        type: GET_GROUPSBYLESSONCOUNT,
        groupsbylessoncount: response.data
      })
    }
    else if (type == 'ParticipantAmounts') {
      dispatch({
        type: GET_PARTICIPANTAMOUNTS,
        participantamounts: response.data
      })
    }
    else if (type == 'TopLeaders') {
      dispatch({
        type: GET_TOPLEADERS,
        topleaders: response.data
      })
    }
    else if (type == 'TopLeadersMore') {
      dispatch({
        type: GET_TOPLEADERSMORE,
        topleaders: response.data
      })
    }
    else if (type == 'FeeOverview') {
      dispatch({
        type: GET_FEEOVERVIEW,
        feeoverview: response.data
      })
    }
    else if (type == 'DebitorsOneYear') {
      dispatch({
        type: GET_DEBITORSONEYEAR,
        debitorsoneyear: response.data
      })
    }
    else if (type == 'DebitorsTwoYear') {
      dispatch({
        type: GET_DEBITORSTWOYEAR,
        debitorstwoyear: response.data
      })
    }
    else if (type == 'DebitorsOneYearMore') {
      dispatch({
        type: GET_DEBITORSONEYEARMORE,
        debitorsoneyear: response.data
      })
    }
    else if (type == 'DebitorsTwoYearMore') {
      dispatch({
        type: GET_DEBITORSTWOYEARMORE,
        debitorstwoyear: response.data
      })
    }
  }
  export function getEnums(endpoint, params, type) {
    return function (dispatch) {
      let d = new Date();
      let t = d.getTime();
      //if (type !== 'GroupsByLessonCount') {
        if (endpoint.indexOf('?') > -1 || params.indexOf('?') > -1) {
          params = params+'&t='+t
        } else {
          params = params+'?t='+t
        }
      //}
      axios.get(ROOT_URL+endpoint+params, {
        headers: {'X-Auth-Token': localStorage.getItem('token')}
        })
        .then(response => {
          // type dependent dispatch
          dispatcher(dispatch, response, type)
        })
        // If request is bad...
        // - Try refresh token
        /*
        .catch(() => {
          axios.post(`${ROOT_URL}/auth.refresh`, {
            token: localStorage.getItem('refreshToken')
          })
            .then(response => {
              // -Save tokens
              localStorage.setItem('token', response.data.accessToken)
              localStorage.setItem('refreshToken', response.data.refreshToken)
              localStorage.setItem('validUntil', response.data.validUntil)

              // -if request is good, we may send again our request
              axios.get(ROOT_URL+endpoint+params, {
                headers: {'X-Auth-Token': localStorage.getItem('token')}
              })
                .then(response => {
                  if (response.status === 200) {
                    // type dependent dispatch
                    dispatcher(dispatch, response, type)
                  } else {
                    if (type !== 'Names') {
                      console.log('signout')
                      signoutUser()
                      this.props.history.push('/login')
                    }
                  }
                })

            })
            .catch((error) => {
              //console.log(error)
              //console.log(error.response)
              let messageplus = '';
              if (typeof error.response.details !== 'undefined') {
                error.response.data.details.map((option, index) => {
                  messageplus = messageplus+JSON.stringify(option)+' '
                })
              }
              alert('Hiba történt. A szerver válasza:'+error.response.data.message+'\n'+messageplus)
              if (type !== 'Names') {
                console.log('signout')
                signoutUser()
                this.props.history.push('/login')
              }
            })
        })
        */
    }
  }
  export function getGroupInit(endpoint, params, type) {
    return function (dispatch) {
      let d = new Date();
      let t = d.getTime();
      //if (endpoint.indexOf('?') > -1 || params.indexOf('?') > -1) {
      //  params = params+'&t='+t
      //} else {
      //  params = params+'?t='+t
      //}
      axios.get(ROOT_URL+endpoint+params+'/participations/self-knowledge'+'?t='+t, {
        headers: {'X-Auth-Token': localStorage.getItem('token')}
      })
      .then(response => {
        if (response.data.length < 1) {
          axios.get(ROOT_URL+endpoint+params+'/participations/training'+'?t='+t, {
            headers: {'X-Auth-Token': localStorage.getItem('token')}
          })
          .then(response => {
            if (response.data.length < 1) {
              axios.get(ROOT_URL+endpoint+params+'/participations/lead'+'?t='+t, {
                headers: {'X-Auth-Token': localStorage.getItem('token')}
              })
              .then(response => {
                if (response.data.length > 0) {
                  // type dependent dispatch
                  dispatcher(dispatch, response, type, 'leadedgroups')
                } else {
                  dispatcher(dispatch, response, type, 'skgroups')
                }
              })
            } else {
              // type dependent dispatch
              dispatcher(dispatch, response, type, 'tgroups')
            }
          })
        } else {
          // type dependent dispatch
          dispatcher(dispatch, response, type, 'skgroups')
        }
      })
    }
  }

// Edit
  export function patchItem(endpoint, params, patchvar, needalert, count) {
    let event;
    if (IE) {
      event = new CustomEvent('patchresponse'+count);
    } else {
      event = new Event('patchresponse'+count);
    }
    let d = new Date();
    let t = d.getTime();
    if (endpoint.indexOf('?') > -1 || params.indexOf('?') > -1) {
      params = params+'&t='+t
    } else {
      params = params+'?t='+t
    }
    return function (dispatch) {
      axios.patch(ROOT_URL+endpoint+params, patchvar, {
        headers: {'X-Auth-Token': localStorage.getItem('token')}
      })
        .then(response => {
          if (response.status < 400 /* and for the edge test: */ || response === undefined /* this should delete */) {
            //if (needalert !== false) {
            //  alert('Sikeres módosítás')
            //}
            if (typeof count !== 'undefined') {
              document.getElementsByTagName("body")[0].dispatchEvent(event).removeEventListener(event);
              //document.getElementsByTagName("body")[0].removeEventListener(event);
            }
          }
        })

        // If request is bad...
        // - Try refresh token
        .catch(error => {
          if (typeof error !== 'undefined' && typeof error.response !== 'undefined') {
            if (error.response.status === 401) {
              axios.post(`${ROOT_URL}/auth.refresh`, {
                token: localStorage.getItem('refreshToken')
              })
              .then(response => {
                // -Save tokens
                localStorage.setItem('token', response.data.accessToken)
                localStorage.setItem('refreshToken', response.data.refreshToken)
                localStorage.setItem('validUntil', response.data.validUntil)

                // -if request is good, we may send again our request
                axios.patch(ROOT_URL+endpoint+params, patchvar, {
                  headers: {'X-Auth-Token': localStorage.getItem('token')}
                })
                  .then(response => {
                    if (response.status === 400) {
                      var messageplus = '';
                      if (typeof response.details !== 'undefined') {
                        response.details.map((option, index) => {
                          messageplus = messageplus+JSON.stringify(option)+' \n'
                        })
                      }
                      alert('Hiba történt. A szerver válasza: '+response.message+'\n'+JSON.stringify(messageplus))
                    } else if (response.status < 400) {
                      //if (needalert !== false) {
                      //  alert('Sikeres módosítás')
                      //}
                      if (typeof count !== 'undefined') {
                        document.getElementsByTagName("body")[0].dispatchEvent(event).removeEventListener(event);
                      }
                    } else {
                      signoutUser()
                      this.props.history.push('/login')
                    }
                  })
                  .catch((error) => {
                    let messageplus = '';
                    if (typeof error.response.details !== 'undefined') {
                      error.response.data.details.map((option, index) => {
                        messageplus = messageplus+JSON.stringify(option)+' \n'
                      })
                    }
                    alert('Hiba történt. A szerver válasza: '+error.response.data.message+'\n'+JSON.stringify(messageplus))

                  })

              })
            } else {
              var messageplus = '';
              if (typeof error.response.data.details !== 'undefined') {
                error.response.data.details.map((option, index) => {
                  messageplus = messageplus+JSON.stringify(option)+' \n'
                })
              }
              if (error.response.data.message === 'error.fee.not-editable') {
                alert('Hiba történt. A szerver válasza: Csak jövőbeli év tagdíja módosítható.'+'\n'+JSON.stringify(messageplus))
                document.getElementsByTagName("body")[0].dispatchEvent('errorp');
              } else {
                alert('Hiba történt. A szerver válasza: '+error.response.data.message+'\n'+JSON.stringify(messageplus))
                document.getElementsByTagName("body")[0].dispatchEvent('errorp');
              }
            }
          } else {
            // For the Edge test - axios in dev mode not have response
            if (error.description === "Network Error") {
              if (typeof count !== 'undefined') {
                document.getElementsByTagName("body")[0].dispatchEvent(event);
                document.getElementsByTagName("body")[0].removeEventListener(event);
              }
            }
          }
        })
    }
  }

// person single
  export function setFilter(params) {
    return function(dispatch) {
      dispatch({
        type: FILTERPARAMS_SET,
        filteroptions: params
      })
    }
  }
  export function filteroptions() {
    return function(dispatch) {
      dispatch({
        type: FILTERPARAMS,
        filteroptions: {
          personal: {
            name: "",
            birthday: "",
            isDead: "---",
            address: {
              zip: "",
              country: "",
              city: "",
              address: "",
            },
            email: "",
            phone: "",
            isPublicContact: "---"
          },
          system: {
            tbNumber: "",
            indexnumber: "",
            isNewsletter: "---",
          },
          psychoterapist: {
            isPatientgroup: "---",
            isTheory: "---",
            isExam: "---",
            isPsychotherapist: "---",
          },
          diplomas: "",
          membershipType: "---",
          qualification: "---",
          comments: "",
        }
      })
    }
  }
  export function openPerson(endpoint, params) {
    return function (dispatch) {
      let d = new Date();
      let t = d.getTime();
      if (endpoint.indexOf('?') > -1 || params.indexOf('?') > -1) {
        params = params+'&t='+t
      } else {
        params = params+'?t='+t
      }
      axios.get(ROOT_URL+endpoint+params, {
        headers: {'X-Auth-Token': localStorage.getItem('token')}
      })
        .then(response => {
          if(typeof response.data.comments !== 'undefined') {
            response.data.comments.map((option, index) => {
              option.time = option.time.replace(/['T']/g, ' ').substring(0,16);
            })
          }
          if(typeof response.data.personal.birthday !== 'undefined') {
            response.data.personal.editedbirthday = new Date(response.data.personal.birthday)
          }
          dispatch({
            type: OPEN_PERSON,
            person: response.data
          })
        })
        // If request is bad...
        // - Try refresh token
        .catch((response) => {
          if (response.status === 401) {
            axios.post(`${ROOT_URL}/auth.refresh`, {
              token: localStorage.getItem('refreshToken')
            })
              .then(response => {
                // -Save tokens
                localStorage.setItem('token', response.data.accessToken)
                localStorage.setItem('refreshToken', response.data.refreshToken)
                localStorage.setItem('validUntil', response.data.validUntil)

                // -if request is good, we may send again our request
                axios.get(ROOT_URL+endpoint+params, {
                  headers: {'X-Auth-Token': localStorage.getItem('token')}
                })
                  .then(response => {
                    if (response.status === 200) {
                      if(typeof response.data.personal.birthday !== 'undefined') {
                        response.data.personal.editedbirthday = new Date(response.data.personal.birthday)
                      }
                      dispatch({
                        type: OPEN_PERSON,
                        person: response.data
                      })
                    } else {
                      signoutUser()
                      this.props.history.push('/login')
                    }
                  })

              })
              .catch(() => {
                signoutUser()
                this.props.history.push('/login')
              })
          } else if (response.status > 401 || response.status === 400) {
            var messageplus = '';
            if (typeof response.details !== 'undefined') {
              response.details.map((option, index) => {
                messageplus = messageplus+option+' '
              })
            }
            alert('Hiba történt. A szerver válasza:'+response.message+'\n'+messageplus)
          }
        })
    }
  }
  export function closePerson(endpoint, params) {
    return function (dispatch) {
      dispatch({
        type: CLOSE_PERSON
      })
    }
  }
  export function personMerge(endpoint, params, mergeObject) {
    document.getElementById("overlay").style.display = "block";
    return function (dispatch) {
      let d = new Date();
      let t = d.getTime();
      if (endpoint.indexOf('?') > -1 || params.indexOf('?') > -1) {
        params = params+'&t='+t
      } else {
        params = params+'?t='+t
      }
      axios.post(ROOT_URL+endpoint+params, mergeObject, {
        headers: {'X-Auth-Token': localStorage.getItem('token')}
      })
        .then(response => {
          document.getElementById("overlay").style.display = "none";
          //document.getElementsByTagName("body")[0].dispatchEvent(updateEvent);
        })
        // If request is bad...
        // - Try refresh token
        .catch((response) => {
          if (response.status === 401) {
            axios.post(`${ROOT_URL}/auth.refresh`, {
              token: localStorage.getItem('refreshToken')
            })
              .then(response => {
                // -Save tokens
                localStorage.setItem('token', response.data.accessToken)
                localStorage.setItem('refreshToken', response.data.refreshToken)
                localStorage.setItem('validUntil', response.data.validUntil)

                // -if request is good, we may send again our request
                axios.post(ROOT_URL+endpoint+params, mergeObject, {
                  headers: {'X-Auth-Token': localStorage.getItem('token')}
                })
                  .then(response => {
                    if (response.status === 200) {
                      document.getElementById("overlay").style.display = "none";
                    } else {
                      signoutUser()
                      this.props.history.push('/login')
                    }
                  })

              })
              .catch(() => {
                signoutUser()
                this.props.history.push('/login')
              })
          } else if (response.status > 401 || response.status === 400) {
            var messageplus = '';
            if (typeof response.details !== 'undefined') {
              response.details.map((option, index) => {
                messageplus = messageplus+option+' '
              })
            }
            alert('Hiba történt. A szerver válasza:'+response.message+'\n'+messageplus)
          }
        })
    }
  }

// person functions
  export function clearNames(endpoint, params) {
    return function (dispatch) {
      dispatch({
        type: GET_NAMES,
        names: false
      })
    }
  }
  export function anonimize(endpoint, params) {
    return function (dispatch) {
      let d = new Date();
      let t = d.getTime();
      if (endpoint.indexOf('?') > -1 || params.indexOf('?') > -1) {
        params = params+'&t='+t
      } else {
        params = params+'?t='+t
      }
      axios.post(ROOT_URL+endpoint+params, '', {
        headers: {'X-Auth-Token': localStorage.getItem('token')}
      })
        .then(response => {
          if (response.status < 400) {
            alert('Sikeres anonimizálás')
            openPerson('/persons', '/'+params);
          }
        })
        // If request is bad...
        // - Try refresh token
        .catch((response) => {
          if (response.status === 401) {
            axios.post(`${ROOT_URL}/auth.refresh`, {
              token: localStorage.getItem('refreshToken')
            })
              .then(response => {
                // -Save tokens
                localStorage.setItem('token', response.data.accessToken)
                localStorage.setItem('refreshToken', response.data.refreshToken)
                localStorage.setItem('validUntil', response.data.validUntil)

                // -if request is good, we may send again our request
                axios.post(ROOT_URL+endpoint+params, '', {
                  headers: {'X-Auth-Token': localStorage.getItem('token')}
                })
                  .then(response => {
                    if (response.status === 400) {
                      var messageplus = '';
                      if (typeof response.details !== 'undefined') {
                        response.details.map((option, index) => {
                          messageplus = messageplus+option+' '
                        })
                      }
                      alert('Hiba történt. A szerver válasza:'+response.message+'\n'+messageplus)
                    } else if (response.status < 400) {
                      alert('Sikeres anonimizálás')
                      openPerson('/persons', '/'+params);
                    } else {
                      signoutUser()
                      this.props.history.push('/login')
                    }
                  })
                  .catch((error) => {
                    let messageplus = '';
                    if (typeof error.response.details !== 'undefined') {
                      error.response.data.details.map((option, index) => {
                        messageplus = messageplus+JSON.stringify(option)+' '
                      })
                    }
                    alert('Hiba történt. A szerver válasza:'+error.response.data.message+'\n'+messageplus)

                  })

              })
          } else if (response.status > 401 || response.status === 400) {
            var messageplus = '';
            if (typeof response.details !== 'undefined') {
              response.details.map((option, index) => {
                messageplus = messageplus+option+' '
              })
            }
            alert('Hiba történt. A szerver válasza:'+response.message+'\n'+messageplus)
          }
        })
    }
  }

// fee single
  export function openFee(endpoint, params, item, type) {
    return function (dispatch) {
      let d = new Date();
      let t = d.getTime();
      if (endpoint.indexOf('?') > -1 || params.indexOf('?') > -1) {
        params = params+'&t='+t
      } else {
        params = params+'?t='+t
      }
      if (item === null) {
        let eddig = params.indexOf('t=')
        let editPathString = params.substring(0, (eddig - 1))
        dispatch({
          type: OPEN_FEE,
          fee: {
            "type" : "",
            "debit" : null,
            "isRemissed" : false,
            "noticeCount" : 0,
            "paymentDate" : undefined,
            "invoiceNumber" : "",
            "reason" : "",
            "editPath" : editPathString
          }
        })
      } else {
        axios.get(ROOT_URL+endpoint+params, {
          headers: {'X-Auth-Token': localStorage.getItem('token')}
        })
          .then(response => {
            if(typeof response.data.amount !== 'undefined') {
              response.data.amount = renderNumber(response.data.amount)
            }
            if(typeof response.data.payed !== 'undefined') {
              response.data.payed = renderNumber(response.data.payed)
            }
            if (typeof response.data.type === 'undefined' && type !== null) {
              response.data.type = type
            }
            if(typeof response.data.editPath === 'undefined') {
              response.data.editPath = params
            }
            response.data.item = item
            dispatch({
              type: OPEN_FEE,
              fee: response.data
            })
          })
          // If request is bad...
          // - Try refresh token
          .catch((response) => {
            if (response.status === 401) {
              axios.post(`${ROOT_URL}/auth.refresh`, {
                token: localStorage.getItem('refreshToken')
              })
                .then(response => {
                  // -Save tokens
                  localStorage.setItem('token', response.data.accessToken)
                  localStorage.setItem('refreshToken', response.data.refreshToken)
                  localStorage.setItem('validUntil', response.data.validUntil)

                  // -if request is good, we may send again our request
                  axios.get(ROOT_URL+endpoint+params, {
                    headers: {'X-Auth-Token': localStorage.getItem('token')}
                  })
                    .then(response => {
                      if (response.status === 200) {
                        if(typeof response.data.editPath == 'undefined') {
                          response.data.editPath = params
                        }
                        if(typeof response.data.amount !== 'undefined') {
                          response.data.amount = renderNumber(response.data.amount)
                        }
                        if(typeof response.data.payed !== 'undefined') {
                          response.data.payed = renderNumber(response.data.payed)
                        }
                        dispatch({
                          type: OPEN_FEE,
                          fee: response.data
                        })
                      } else {
                        signoutUser()
                        this.props.history.push('/login')
                      }
                    })

                })
                .catch(() => {
                  signoutUser()
                  this.props.history.push('/login')
                })
            } else if (response.status > 401 || response.status === 400) {
              var messageplus = '';
              if (typeof response.details !== 'undefined') {
                response.details.map((option, index) => {
                  messageplus = messageplus+option+' '
                })
              }
              alert('Hiba történt. A szerver válasza:'+response.message+'\n'+messageplus)
            }
          })
      }
    }
  }
  export function closeFee(endpoint, params) {
    return function (dispatch) {
      dispatch({
        type: CLOSE_FEE
      })
    }
  }

// affair single
  export function openAffair(endpoint, params, item, name) {
    return function (dispatch) {
      let d = new Date();
      let t = d.getTime();
      if (endpoint.indexOf('?') > -1 || params.indexOf('?') > -1 || ( item !== null && item.indexOf('?') > -1)) {
        params = params+'&t='+t
      } else {
        params = params+'?t='+t
      }
      if (item === null) {
        let actualdate = new Date();
        actualdate.setMinutes(actualdate.getMinutes() - actualdate.getTimezoneOffset());
        actualdate = actualdate.toISOString().slice(0,10)
        dispatch({
          type: OPEN_AFFAIR,
          affair: {
            "name": null,
            "id" : params,
            "creation" : actualdate,
            "comments" : [],
            "history" : [
              {
                status: "folyamatban",
                date: actualdate
              }
            ]
          }
        })
      } else {
        axios.get(ROOT_URL+'/persons/'+item+endpoint+params, {
          headers: {'X-Auth-Token': localStorage.getItem('token')}
        })
          .then(response => {
            response.data.name = name
            response.data.item = item
            dispatch({
              type: OPEN_AFFAIR,
              affair: response.data
            })
          })
          // If request is bad...
          // - Try refresh token
          .catch((response) => {
            if (response.status === 401) {
              axios.post(`${ROOT_URL}/auth.refresh`, {
                token: localStorage.getItem('refreshToken')
              })
              .then(response => {
                // -Save tokens
                localStorage.setItem('token', response.data.accessToken)
                localStorage.setItem('refreshToken', response.data.refreshToken)
                localStorage.setItem('validUntil', response.data.validUntil)

                // -if request is good, we may send again our request
                axios.get(ROOT_URL+'/persons/'+item+endpoint+params, {
                  headers: {'X-Auth-Token': localStorage.getItem('token')}
                })
                  .then(response => {
                    if (response.status === 200) {
                      response.data.name = name
                      response.data.item = item
                      dispatch({
                        type: OPEN_AFFAIR,
                        affair: response.data
                      })
                    } else {
                      // console.log('signout')
                      signoutUser()
                      this.props.history.push('/login')
                    }
                  })

              })
              .catch(() => {
                // console.log('signout')
                signoutUser()
                this.props.history.push('/login')
              })
            } else if (response.status > 401 || response.status === 400) {
              var messageplus = '';
              if (typeof response.details !== 'undefined') {
                response.details.map((option, index) => {
                  messageplus = messageplus+option+' '
                })
              }
              alert('Hiba történt. A szerver válasza:'+response.message+'\n'+messageplus)
            }
          })
      }
    }
  }
  export function closeAffair(endpoint, params) {
    return function (dispatch) {
      dispatch({
        type: CLOSE_AFFAIR
      })
    }
  }

// setting single
  export function openSetting(endpoint, params, item, name) {
    return function (dispatch) {
        let d = new Date();
        let t = d.getTime();
        if (endpoint.indexOf('?') > -1 || params.indexOf('?') > -1) {
          params = params+'&t='+t
        } else {
          params = params+'?t='+t
        }
        axios.get(ROOT_URL+endpoint+params, {
          headers: {'X-Auth-Token': localStorage.getItem('token')}
        })
          .then(response => {
            if(typeof response.data.supporter !== 'undefined') {
              response.data.supporter = renderNumber(response.data.supporter)
            }
            if(typeof response.data.normal !== 'undefined') {
              response.data.normal = renderNumber(response.data.normal)
            }
            dispatch({
              type: OPEN_SETTING,
              setting: response.data
            })
          })
          // If request is bad...
          // - Try refresh token
          .catch((response) => {
            if (response.status === 401) {
              axios.post(`${ROOT_URL}/auth.refresh`, {
                token: localStorage.getItem('refreshToken')
              })
                .then(response => {
                  // -Save tokens
                  localStorage.setItem('token', response.data.accessToken)
                  localStorage.setItem('refreshToken', response.data.refreshToken)
                  localStorage.setItem('validUntil', response.data.validUntil)

                  // -if request is good, we may send again our request
                  axios.get(ROOT_URL+endpoint+params, {
                    headers: {'X-Auth-Token': localStorage.getItem('token')}
                  })
                    .then(response => {
                      if (response.status === 200) {
                        if(typeof response.data.supporter !== 'undefined') {
                          response.data.supporter = renderNumber(response.data.supporter)
                        }
                        if(typeof response.data.normal !== 'undefined') {
                          response.data.normal = renderNumber(response.data.normal)
                        }
                        dispatch({
                          type: OPEN_SETTING,
                          setting: response.data
                        })
                      } else {
                        // console.log('signout')
                        signoutUser()
                        this.props.history.push('/login')
                      }
                    })

                })
                .catch(() => {
                  // console.log('signout')
                  signoutUser()
                  this.props.history.push('/login')
                })
            } else if (response.status > 401 || response.status === 400) {
              var messageplus = '';
              if (typeof response.details !== 'undefined') {
                response.details.map((option, index) => {
                  messageplus = messageplus+option+' '
                })
              }
              alert('Hiba történt. A szerver válasza:'+response.message+'\n'+messageplus)
            }
          })

    }
  }
  export function closeSetting(endpoint, params) {
    return function (dispatch) {
      dispatch({
        type: CLOSE_SETTING
      })
    }
  }

// groups single
  export function openGroup(endpoint, params, isSaved) {
    return function (dispatch) {
      if (isSaved !== false) {
        isSaved = true;
      }
      // console.log("openGroup start")
      // console.log(isSaved)
      let d = new Date();
      let t = d.getTime();
      if (endpoint.indexOf('?') > -1 || params.indexOf('?') > -1) {
        params = params+'&t='+t
      } else {
        params = params+'?t='+t
      }
      axios.get(ROOT_URL+endpoint+params, {
        headers: {'X-Auth-Token': localStorage.getItem('token')}
      })
        .then(response => {
          if(typeof response.data.groupRegistrationFee !== 'undefined' && typeof response.data.groupRegistrationFee.amount !== 'undefined') {
            response.data.groupRegistrationFee.amount = renderNumber(response.data.groupRegistrationFee.amount)
          }
          if(typeof response.data.groupRegistrationFee !== 'undefined' && typeof response.data.groupRegistrationFee.payed !== 'undefined') {
            response.data.groupRegistrationFee.payed = renderNumber(response.data.groupRegistrationFee.payed)
          }
          response.data.isSaved = isSaved
          // console.log('dispatch OPEN_GROUP')
          dispatch({
            type: OPEN_GROUP,
            group: response.data
          })
        })
        // If request is bad...
        // - Try refresh token
        .catch((response) => {
          if (response.status === 401) {
            axios.post(`${ROOT_URL}/auth.refresh`, {
              token: localStorage.getItem('refreshToken')
            })
              .then(response => {
                 // console.log("openGroup in catch have response")
                // -Save tokens
                localStorage.setItem('token', response.data.accessToken)
                localStorage.setItem('refreshToken', response.data.refreshToken)
                localStorage.setItem('validUntil', response.data.validUntil)

                // -if request is good, we may send again our request
                axios.get(ROOT_URL+endpoint+params, {
                  headers: {'X-Auth-Token': localStorage.getItem('token')}
                })
                  .then(response => {
                    if (response.status === 200) {
                      if(typeof response.data.groupRegistrationFee.amount !== 'undefined') {
                        response.data.groupRegistrationFee.amount = renderNumber(response.data.groupRegistrationFee.amount)
                      }
                      if(typeof response.data.groupRegistrationFee.payed !== 'undefined') {
                        response.data.groupRegistrationFee.payed = renderNumber(response.data.groupRegistrationFee.payed)
                      }
                      response.data.isSaved = isSaved
                      dispatch({
                        type: OPEN_GROUP,
                        group: response.data
                      })
                    } else {
                      // console.log('signout')
                      signoutUser()
                      this.props.history.push('/login')
                    }
                  })

              })
              .catch(() => {
                // console.log('signout')
                signoutUser()
                this.props.history.push('/login')
              })
          } else if (response.status > 401 || response.status === 400) {
            var messageplus = '';
            if (typeof response.details !== 'undefined') {
              response.details.map((option, index) => {
                messageplus = messageplus+option+' '
              })
            }
            alert('Hiba történt. A szerver válasza:'+response.message+'\n'+messageplus)
          }
        })
    }
  }
  export function deleteParticipant(endpoint, params, count) {
    let event;
    if (IE) {
      event = new CustomEvent('patchresponse'+count);
    } else {
      event = new Event('patchresponse'+count);
    }
    // let event = new Event('patchresponse'+count);
    return function (dispatch) {
      let d = new Date();
      let t = d.getTime();
      if (endpoint.indexOf('?') > -1 || params.indexOf('?') > -1) {
        params = params+'&t='+t
      } else {
        params = params+'?t='+t
      }
      axios.delete(ROOT_URL+endpoint+params, {
        headers: {'X-Auth-Token': localStorage.getItem('token')}
      })
        .then(response => {
          //console.log(response.status) -> 204
          if (response.status < 400) {
            if (typeof count !== 'undefined') {
              document.getElementsByTagName("body")[0].dispatchEvent(event);
              document.getElementsByTagName("body")[0].removeEventListener(event);
            }
          }
        })
        // If request is bad...
        // - Try refresh token
        .catch((error) => {
          if (typeof error !== 'undefined' && typeof error.response !== 'undefined') {
            if (error.response.status === 401) {
              axios.post(`${ROOT_URL}/auth.refresh`, {
                token: localStorage.getItem('refreshToken')
              })
                .then(response => {
                  // -Save tokens
                  localStorage.setItem('token', response.data.accessToken)
                  localStorage.setItem('refreshToken', response.data.refreshToken)
                  localStorage.setItem('validUntil', response.data.validUntil)

                  // -if request is good, we may send again our request
                  axios.delete(ROOT_URL+endpoint+params, {
                    headers: {'X-Auth-Token': localStorage.getItem('token')}
                  })
                    .then(response => {
                      if (response.status < 400) {
                        if (typeof count !== 'undefined') {
                          document.getElementsByTagName("body")[0].dispatchEvent(event);
                          document.getElementsByTagName("body")[0].removeEventListener(event);
                        }
                      } else {
                        // console.log('signout')
                        signoutUser()
                        this.props.history.push('/login')
                      }
                    })

                })
                .catch(() => {
                  // console.log('signout')
                  signoutUser()
                  this.props.history.push('/login')
                })
            } else if (error.response.status > 401 || error.response.status === 400) {
              var messageplus = '';
              if (typeof error.response.details !== 'undefined') {
                error.response.details.map((option, index) => {
                  messageplus = messageplus+option+' '
                })
              }
              if (typeof count !== 'undefined') {
                // console.log('sikertelen törlés')
                document.getElementsByTagName("body")[0].dispatchEvent(event);
                document.getElementsByTagName("body")[0].removeEventListener(event);
              }
              alert('Hiba történt a résztvevők törlésekor. A szerver válasza:'+error.response.message+'\n'+messageplus)
            }
          }
        })
    }
  }
  export function closeGroup(endpoint, params) {
    return function (dispatch) {
      dispatch({
        type: CLOSE_GROUP
      })
    }
  }
  export function openGroupregistrationfee(endpoint, params, item) {
    return function (dispatch) {
      let d = new Date();
      let t = d.getTime();
      if (endpoint.indexOf('?') > -1 || params.indexOf('?') > -1) {
        params = params+'&t='+t
      } else {
        params = params+'?t='+t
      }
      if (item === null) {
        dispatch({
          type: OPEN_GROUPREGISTRATIONFEE,
          groupregistrationfee: {
            "amount" : "",
            "payed" : "0",
            "paymentDate" : undefined,
            "invoiceNumber" : undefined
          }
        })
      } else {
        axios.get(ROOT_URL+endpoint+params, {
          headers: {'X-Auth-Token': localStorage.getItem('token')}
        })
          .then(response => {
            dispatch({
              type: OPEN_GROUPREGISTRATIONFEE,
              groupregistrationfee: response.data
            })
          })
          // If request is bad...
          // - Try refresh token
          .catch((response) => {
            if (response.status === 401) {
              axios.post(`${ROOT_URL}/auth.refresh`, {
                token: localStorage.getItem('refreshToken')
              })
                .then(response => {
                  // -Save tokens
                  localStorage.setItem('token', response.data.accessToken)
                  localStorage.setItem('refreshToken', response.data.refreshToken)
                  localStorage.setItem('validUntil', response.data.validUntil)

                  // -if request is good, we may send again our request
                  axios.get(ROOT_URL+endpoint+params, {
                    headers: {'X-Auth-Token': localStorage.getItem('token')}
                  })
                    .then(response => {
                      if (response.status === 200) {
                        dispatch({
                          type: OPEN_GROUPREGISTRATIONFEE,
                          groupregistrationfee: response.data
                        })
                      } else {
                        // console.log('signout')
                        signoutUser()
                        this.props.history.push('/login')
                      }
                    })

                })
                .catch(() => {
                  // console.log('signout')
                  signoutUser()
                  this.props.history.push('/login')
                })
            } else if (response.status > 401 || response.status === 400) {
              var messageplus = '';
              if (typeof response.details !== 'undefined') {
                response.details.map((option, index) => {
                  messageplus = messageplus+option+' '
                })
              }
              alert('Hiba történt. A szerver válasza:'+response.message+'\n'+messageplus)
            }
          })
      }
    }
  }



// WEBPACK FOOTER //
// ./src/actions/index.js